import { createAction } from '@ngrx/store';

export const GENERIC_NOOP = '[Generic] No-op';

export const genericNoopAction = createAction(GENERIC_NOOP);
